import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

interface FieldProps {
  label?: ReactNode;
  hint?: ReactNode;
  error?: string | null;
  required?: boolean;
  children: ReactNode;
  className?: string;
}

export function Field({ label, hint, error, required, children, className }: FieldProps) {
  return (
    <div className={cn("flex flex-col gap-2", className)}>
      {label ? (
        <label className="text-[14px] font-semibold text-[#2563eb]">
          {label}
          {required ? <span className="ml-0.5 text-[#ef4444]">*</span> : null}
        </label>
      ) : null}
      {children}
      {error ? (
        <p className="text-[13px] text-[#991b1b]">{error}</p>
      ) : hint ? (
        <p className="text-[13px] text-[#6c757d]">{hint}</p>
      ) : null}
    </div>
  );
}
